<template>
  <v-container>
    <v-app>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="lotojr_colorPrimary"
        dark
      >
        <div class="d-flex align-center" style="margin-right: 50px">
          <v-img
            :src="require('../../assets/rsz_logo.png')"
            class="my-3"
            contain
            width="100"
          />
        </div>
      </v-app-bar>
      <v-layout justify-center align-center style="margin-top: 65px">
        <v-card
          v-if="deuCerto"
          class="card-rounded center"
          min-width="350"
          max-width="750"
          outlined
        >
          <v-card-title class="signup-title"
            >Conta ativada com sucesso!!!</v-card-title
          >
          <v-card-title class="signup-title"
            >Pode efetuar login pelo aplicativo!</v-card-title
          >
        </v-card>
        <v-card
          v-if="NaodeuCerto"
          class="card-rounded center"
          min-width="350"
          max-width="750"
          outlined
        >
          <v-card-title class="signup-title-n"
            >Conta não encontrada</v-card-title
          >
        </v-card>
      </v-layout>
    </v-app>
  </v-container>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

export default {
  data() {
    return {
      profile: {},
      NaodeuCerto: false,
      deuCerto: false,
      nomeRules: null,
      emailRules: null,
      cpfRules: null,
      dtpData: 0,
      password: null,
      confirmPassword: null,
      urlIndicacao: null,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      requiredRules: null,
      //image: "",
    };
  },

  computed: {},
  methods: {
    ativa() {
      this.$store
        .dispatch("ativarConta", this.$route.query.h)
        .then((value) => {
           if (value) {
            this.deuCerto = true;
          } else {
            this.NaodeuCerto = true;
          }
        })
        .catch((err) => {
            this.NaodeuCerto = true;

        });
    },
  },
  beforeMount() {
    this.ativa();
  },
};
</script>
<style scoped>
.signup-title {
  background-color: green;
  color: white;
}
.signup-title-n {
  background-color: red;
  color: white;
}
.signup-form-input {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
* {
  font-family: "Arial";
  font-size: 12px;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
}

html,
body {
  height: 100%;
  text-align: center;
}

.btn {
  background-color: #d3394c;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding: 15px 35px;
  position: relative;
}

.btn:hover {
  background-color: #722040;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.align-center {
  text-align: center;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
}

.hidden.image {
  display: inline-block !important;
}

.display-inline {
  display: inline-block;
  vertical-align: middle;
}

.img {
  border: 1px solid #f6f6f6;
  display: inline-block;
  height: auto;
  max-height: 80%;
  max-width: 80%;
  width: auto;
}

.drop {
  background-color: #f2f2f2;
  border: 4px dashed #ccc;
  background-color: #f6f6f6;
  border-radius: 2px;
  height: 100%;
  max-height: 400px;
  max-width: 600px;
  width: 100%;
}
</style>
